import { useState } from 'react';
import { marketApi } from '../../../lib/api';
import { toast } from 'sonner';

export const useMarketActions = ({ isItalian }) => {
  const [marketStatus, setMarketStatus] = useState({ is_open: true });
  const [togglingMarket, setTogglingMarket] = useState(false);
  const [showScheduleModal, setShowScheduleModal] = useState(false);
  const [scheduleOpenAt, setScheduleOpenAt] = useState('');
  const [scheduleCloseAt, setScheduleCloseAt] = useState('');
  const [savingSchedule, setSavingSchedule] = useState(false);

  const handleToggleMarket = async () => {
    setTogglingMarket(true);
    try {
      if (marketStatus.is_open) {
        await marketApi.close(isItalian ? 'Il mercato è attualmente chiuso' : 'The market is currently closed');
        setMarketStatus(prev => ({ ...prev, is_open: false }));
        toast.success(isItalian ? 'Mercato chiuso!' : 'Market closed!');
      } else {
        await marketApi.open();
        setMarketStatus(prev => ({ ...prev, is_open: true }));
        toast.success(isItalian ? 'Mercato aperto!' : 'Market opened!');
      }
    } catch (error) {
      toast.error(error.response?.data?.detail || (isItalian ? 'Errore' : 'Error'));
    } finally {
      setTogglingMarket(false);
    }
  };

  const handleSaveSchedule = async () => {
    setSavingSchedule(true);
    try {
      const payload = {};
      if (scheduleOpenAt) payload.open_at = new Date(scheduleOpenAt).toISOString();
      else payload.open_at = '';
      if (scheduleCloseAt) payload.close_at = new Date(scheduleCloseAt).toISOString();
      else payload.close_at = '';
      if (!scheduleOpenAt && !scheduleCloseAt) { payload.open_at = ''; payload.close_at = ''; }

      const res = await marketApi.schedule(payload);
      setMarketStatus(prev => ({ ...prev, open_at: res.data.open_at, close_at: res.data.close_at, is_open: res.data.is_open }));
      toast.success(isItalian ? 'Programmazione salvata!' : 'Schedule saved!');
      setShowScheduleModal(false);
    } catch (error) {
      toast.error(error.response?.data?.detail || (isItalian ? 'Errore programmazione' : 'Schedule error'));
    } finally {
      setSavingSchedule(false);
    }
  };

  return {
    marketStatus, setMarketStatus, togglingMarket, handleToggleMarket,
    showScheduleModal, setShowScheduleModal,
    scheduleOpenAt, setScheduleOpenAt,
    scheduleCloseAt, setScheduleCloseAt,
    savingSchedule, handleSaveSchedule,
  };
};
